import type { ReactNode } from 'react';

/** The sticky bar at the bottom of the client plan: Back on the left, next actions on the right. */
export function OnboardingFooterBar({ back, actions }: { back?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="border-border bg-background sticky bottom-0 z-20 border-t p-4 pr-20 md:p-6 md:pr-20 xl:pr-6">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-2 sm:gap-4">
        <div>{back}</div>
        <div className="flex flex-wrap items-center gap-3 md:ml-auto">{actions}</div>
      </div>
    </div>
  );
}
